// extracted by mini-css-extract-plugin
export default {"menuButton":"MenuButton_menuButton__MBfGf"};